// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"d70606f5","124":"cff9b150","353":"a6ae83c4","449":"0ffb5098","453":"87e45203","660":"dff304d2","697":"31498dcd","712":"e5c02456","819":"76d00ca9"}[chunkId] + ".chunk.js";
};